import i18next from 'i18next';
import {isTouchDevice} from '../../../utils/isTouchDevice';

const WHATSAPP_SHARE_LINK = isTouchDevice()
  ? 'whatsapp://send/'
  : 'https://api.whatsapp.com/send';
const SMS_SHARE_LINK = 'sms://';
const EMAIL_SHARE_LINK = 'mailto:%20';

const canShareNative = (): boolean =>
  typeof navigator !== 'undefined' && typeof navigator.share === 'function';

function getEmailSubjectAndBody(housingName = '', shareLink: string | null = '') {
  return {
    subject: i18next.t('complete_online_checkin_email_subject'),
    body: i18next.t('complete_online_checkin_email_body', {
      housingName,
      link: shareLink,
    }),
  };
}

function getShareMessage(housingName = '', shareLink: null | string = '') {
  return i18next.t('complete_iden_verif_whatsapp', {
    housingName,
    link: shareLink,
  });
}

const canShareBySMS = isTouchDevice;

const shareByNative = (housingName: string, link: string) => {
  navigator.share({text: getShareMessage(housingName, link)}).catch(() => undefined);
};

const shareByWhatsapp = (housingName: string, link: string) => {
  window.open(
    `${WHATSAPP_SHARE_LINK}?text=${encodeURIComponent(
      getShareMessage(housingName, link),
    )}`,
  );
};

const shareBySMS = (housingName: string, link: string) => {
  window.open(
    `${SMS_SHARE_LINK};?&body=${encodeURIComponent(getShareMessage(housingName, link))}`,
  );
};

const shareByEmail = (housingName: string, link: string) => {
  const email = getEmailSubjectAndBody(housingName, link);
  window.open(
    `${EMAIL_SHARE_LINK}?subject=${encodeURIComponent(
      email.subject,
    )}&body=${encodeURIComponent(email.body)}`,
  );
};

export {
  canShareBySMS,
  canShareNative,
  shareByNative,
  shareByWhatsapp,
  shareBySMS,
  shareByEmail,
  WHATSAPP_SHARE_LINK,
  SMS_SHARE_LINK,
  EMAIL_SHARE_LINK,
};
